import { Injector, Component, ViewEncapsulation, Inject, OnInit } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DOCUMENT } from '@angular/common';

@Component({
    templateUrl: './default-brand.component.html',
    selector: 'default-brand',
    encapsulation: ViewEncapsulation.None
})
export class DefaultBrandComponent extends AppComponentBase implements OnInit{

    // defaultLogo = AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-' + this.currentTheme.baseSettings.menu.asideSkin + '.svg';
    defaultLogo = AppConsts.appBaseUrl + '/assets/common/images/CAP-Charity.jpg';
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    currentLanguage: abp.localization.ILanguageInfo;
    currentLanguageName: string;
    isRightToLeft: boolean;

    constructor(
        injector: Injector,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.currentLanguage = this.localization.currentLanguage;
        this.currentLanguageName = this.currentLanguage.name;
        if(this.currentLanguageName == "fa" || this.currentLanguageName == "ar"){
            this.isRightToLeft = true;
        }else{
            this.isRightToLeft = false;
        }
    }

    toggleLeftAside(): void {
        this.document.body.classList.toggle('kt-aside--minimize');
    }
}
